// extracted by mini-css-extract-plugin
export var companySliderContainer = "CompanySlider-module--companySliderContainer--qIkfu";
export var chevronContainer = "CompanySlider-module--chevronContainer--3pJpn";
export var chevron = "CompanySlider-module--chevron--37dA_";
export var right = "CompanySlider-module--right--1_6Ig";
export var companies = "CompanySlider-module--companies--3JZwB";
export var imageContainer = "CompanySlider-module--imageContainer--3djGL";
export var image = "CompanySlider-module--image--3mz4p";